// extracted by mini-css-extract-plugin
export default {"hexGrid":"hexagons_hexGrid__Hv9xH","hex":"hexagons_hex__sgQ2c","hexIn":"hexagons_hexIn__FOm4y","hexLink":"hexagons_hexLink__DDdc7"};